module.exports = __webpack_public_path__ + "../resources/img/test_pop_img.c1ac1426.png";